import { render, staticRenderFns } from "./DigitalMarketingLanding.vue?vue&type=template&id=1aac2b94&scoped=true"
import script from "./DigitalMarketingLanding.vue?vue&type=script&lang=js"
export * from "./DigitalMarketingLanding.vue?vue&type=script&lang=js"
import style0 from "./DigitalMarketingLanding.vue?vue&type=style&index=0&id=1aac2b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac2b94",
  null
  
)

export default component.exports